// AwnFormUI.js
import React from "react";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Awn3.css";

function AwnFormUI(props) {
  const formLabel = (text) => (
    <Form.Label column sm="6" className="form-label-style">
      {text}
    </Form.Label>
  );

  return (
    <div>
      <br />
      {props.isSubmitted && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Alert
            variant="success"
            onClose={() => props.setIsSuccess(false)}
            dismissible
          >
            AWN Entry Submitted Successfully! Please Download the file.
          </Alert>
          <Button
            className="awnB"
            onClick={props.handleDownload}
            variant="success"
          >
            Download AWN
          </Button>
        </div>
      )}

      {props.showAlert && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Alert
            variant="danger"
            onClose={() => props.setShowAlert(false)}
            dismissible
            style={{ width: "95%", marginTop: "20px" }}
          >
            {props.errorMessage}
          </Alert>
        </div>
      )}

      
      {/* --- FORM SECTION 1 --- */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '20px' }}>
        <div className="d-flex flex-column justify-content-center p-4 custom-class" style={{ backgroundColor: "white", color: "black", border: "1px solid lightgrey", width: "95%" }}>
          <Form noValidate>
            <Row>
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Submission Date:")}
                  <Col sm="6">
                    <DatePicker selected={props.submissionDate} onChange={(date) => props.setSubmissionDate(date)} dateFormat="dd/MM/yyyy" className="custom-date-picker form-control" disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Job Number:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.jobNumber} onChange={props.handleJob} isInvalid={!!props.errors.jobNumber} />
                    <Form.Control.Feedback type="invalid">{props.errors.jobNumber}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Project Name:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.projectName} onChange={(e) => props.setProjectName(e.target.value)} isInvalid={!!props.errors.projectName} />
                    <Form.Control.Feedback type="invalid">{props.errors.projectName}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Project Type:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.projectType} onChange={(e) => props.setProjectType(e.target.value)} isInvalid={!!props.errors.projectType} />
                    <Form.Control.Feedback type="invalid">{props.errors.projectType}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Researcher In Charge:")}
                  <Col sm="6">
                    {/* ✅ FIX: Ensure the value is the user's ID (the Primary Key), not the profile ID or name. */}
                    <Form.Control as="select" value={props.researcherCharge} onChange={(e) => props.setResearcherCharge(e.target.value)} isInvalid={!!props.errors.researcherCharge}>
                      <option value="">Select Researcher</option>
                      {/* Assuming 'researchers' is an array of objects like { id, name, user_id } */}
                      {Array.isArray(props.researchers) && [...props.researchers].sort((a, b) => a.name.localeCompare(b.name)).map((profile) => (
                        <option key={profile.id} value={profile.user_id}>
                          {profile.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{props.errors.researcherCharge}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Researcher Cost Center(KSA/UAE):")}
                  <Col sm="6">
                    <Form.Control as="select" value={props.researcherCost} onChange={(e) => props.setResearcherCost(e.target.value)} isInvalid={!!props.errors.researcherCost}>
                      <option value="" hidden>KSA/UAE</option>
                      <option value="4SIGHT KSA">4SIGHT KSA</option>
                      <option value="4SIGHT UAE">4SIGHT UAE</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{props.errors.researcherCost}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Col>
              
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Segment Name:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.segmentName} onChange={(e) => props.setSegmentName(e.target.value)} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Client Name:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.clientName} onChange={(e) => props.setClientName(e.target.value)} isInvalid={!!props.errors.clientName} />
                    <Form.Control.Feedback type="invalid">{props.errors.clientName}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Final Questionnaire Will Be Provided On:")}
                  <Col sm="6">
                    <DatePicker selected={props.finalQuestionnaire} onChange={(date) => props.setFinalQuestionnaire(date)} dateFormat="dd/MM/yyyy" className={`custom-date-picker form-control ${props.errors.finalQuestionnaire ? 'is-invalid' : ''}`} onKeyDown={(e) => e.preventDefault()} />
                    <div className="invalid-feedback d-block">{props.errors.finalQuestionnaire}</div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Scripting Needed:")}
                  <Col sm="6">
                    <Form.Control as="select" value={props.scirptingNeeded} onChange={(e) => props.setScirptingNeeded(e.target.value)} isInvalid={!!props.errors.scirptingNeeded}>
                      <option value="" hidden>Yes/No</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{props.errors.scirptingNeeded}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("If Yes, does it have any Complex Logic*")}
                  <Col sm="6">
                    <Form.Control as="select" value={props.complexLogic} onChange={(e) => props.setComplexLogic(e.target.value)} isInvalid={!!props.errors.complexLogic}>
                      <option value="" hidden>Yes/No</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{props.errors.complexLogic}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Sample Size:")}
                  <Col sm="6">
                    <Form.Control type="text" value={props.sampleSize} onChange={props.handleSampleSizeChange} isInvalid={!!props.errors.sampleSize} />
                    <Form.Control.Feedback type="invalid">{props.errors.sampleSize}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Data Collection Method(CAPI/CAWI):")}
                  <Col sm="6">
                    <Form.Control as="select" value={props.dataCollection} onChange={(e) => props.setDataCollection(e.target.value)} isInvalid={!!props.errors.dataCollection}>
                      <option value="" hidden>CAPI/CAWI</option>
                      <option value="CAPI">CAPI</option>
                      <option value="CAWI">CAWI</option>
                      <option value="Online">Online</option>
                      <option value="Database">Database</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{props.errors.dataCollection}</Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      {/* --- FORM SECTION 2 --- */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <div
          className="d-flex flex-column justify-content-center p-4 custom-class"
          style={{
            backgroundColor: "white",
            color: "black",
            border: "1px solid lightgrey",
            width: "95%",
          }}
        >
          <Form noValidate>
            <Row>
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Have S2C Subscription:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.haveS2CSub}
                      onChange={(e) => props.setHaveS2CSub(e.target.value)}
                      isInvalid={!!props.errors.haveS2CSub}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.haveS2CSub}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Quota:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.quota}
                      onChange={(e) => props.setQuota(e.target.value)}
                      isInvalid={!!props.errors.quota}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.quota}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Quota/Launch Details will be Provided On:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.quotaDetails}
                      onChange={(date) => props.setQuotaDetails(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.quotaDetails ? "is-invalid" : ""
                      }`}
                      disabled={props.quota !== "Yes"}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.quotaDetails}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Expected Field Work Completion Date:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.expectedFieldDate}
                      onChange={(date) => props.setExpectedFieldDate(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.expectedFieldDate ? "is-invalid" : ""
                      }`}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.expectedFieldDate}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Expected Final Link Date:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.expectedFinalLinkDate}
                      onChange={(date) => props.setExpectedFinalLinkDate(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.expectedFinalLinkDate ? "is-invalid" : ""
                      }`}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.expectedFinalLinkDate}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Analysis Plan/Top Break will be Provided On:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.analysisPlan}
                      onChange={(date) => props.setAnalysisPlan(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.analysisPlan ? "is-invalid" : ""
                      }`}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.analysisPlan}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("First Cut/Mid Sample Date:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.firstCutDate}
                      onChange={(date) => props.setFirstCutDate(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.firstCutDate ? "is-invalid" : ""
                      }`}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.firstCutDate}
                    </div>
                  </Col>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel(
                    "Do you need statement fixed format (if applicable)"
                  )}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.statementFF}
                      onChange={(e) => props.setStatementFF(e.target.value)}
                      isInvalid={!!props.errors.statementFF}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.statementFF}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Sig Testing:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.sigTesting}
                      onChange={(e) => props.setSigTesting(e.target.value)}
                      isInvalid={!!props.errors.sigTesting}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.sigTesting}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  className={`mb-3 ${props.errors.options ? "is-invalid" : ""}`}
                >
                  <Row>
                    {formLabel("Sig Testing Check:")}
                    <Col sm="6" className="d-flex align-items-center">
                      <Row>
                        <Col>
                          <Form.Check
                            type="checkbox"
                            label="95%"
                            checked={props.option1}
                            onChange={(e) => props.setOption1(e.target.checked)}
                            disabled={props.sigTesting !== "Yes"}
                          />
                        </Col>
                        <Col>
                          <Form.Check
                            type="checkbox"
                            label="90%"
                            checked={props.option2}
                            onChange={(e) => props.setOption2(e.target.checked)}
                            disabled={props.sigTesting !== "Yes"}
                          />
                        </Col>
                        <Col>
                          <Form.Check
                            type="checkbox"
                            label="80%"
                            checked={props.option3}
                            onChange={(e) => props.setOption3(e.target.checked)}
                            disabled={props.sigTesting !== "Yes"}
                          />
                        </Col>
                        <Col>
                          <Form.Check
                            type="checkbox"
                            label="67%"
                            checked={props.option4}
                            onChange={(e) => props.setOption4(e.target.checked)}
                            disabled={props.sigTesting !== "Yes"}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div
                    className="invalid-feedback d-block"
                    style={{ marginLeft: "50%" }}
                  >
                    {props.errors.options}
                  </div>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("SPSS OUTPUT:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.spssOutput}
                      onChange={(e) => props.setSpssOutput(e.target.value)}
                      isInvalid={!!props.errors.spssOutput}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.spssOutput}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Final Output (Date):")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.finalOutput}
                      onChange={(date) => props.setFinalOutput(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.finalOutput ? "is-invalid" : ""
                      }`}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.finalOutput}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Data Weighting Required:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.dataWeightingRequired}
                      onChange={(e) =>
                        props.setDataWeightingRequired(e.target.value)
                      }
                      isInvalid={!!props.errors.dataWeightingRequired}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.dataWeightingRequired}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Weighting Matrix Will be Provided on:")}
                  <Col sm="6">
                    <DatePicker
                      selected={props.weightingMatrix}
                      onChange={(date) => props.setWeightingMatrix(date)}
                      dateFormat="dd/MM/yyyy"
                      className={`custom-date-picker form-control ${
                        props.errors.weightingMatrix ? "is-invalid" : ""
                      }`}
                      disabled={props.dataWeightingRequired !== "Yes"}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    <div className="invalid-feedback d-block">
                      {props.errors.weightingMatrix}
                    </div>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      {/* --- FORM SECTION 3 --- */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <div
          className="d-flex flex-column justify-content-center p-4 custom-class"
          style={{
            backgroundColor: "white",
            color: "black",
            border: "1px solid lightgrey",
            width: "95%",
          }}
        >
          <Form noValidate>
            <Row>
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel("MAXDIFF Programming:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.maxdiffProgramming}
                      onChange={(e) =>
                        props.setMaxdiffProgramming(e.target.value)
                      }
                      isInvalid={!!props.errors.maxdiffProgramming}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.maxdiffProgramming}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Number of Attributes:")}
                  <Col sm="6">
                    <Form.Control
                      type="text"
                      value={props.numberOfAttributes}
                      onChange={props.handleNoaChange}
                      disabled={props.maxdiffProgramming !== "Yes"}
                      isInvalid={!!props.errors.numberOfAttributes}
                    />
                    <Form.Control.Feedback type="invalid">
                      {props.errors.numberOfAttributes}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Jaccards:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.jaccards}
                      onChange={(e) => props.setJaccards(e.target.value)}
                      isInvalid={!!props.errors.jaccards}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.jaccards}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Regression (Importance Score):")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.regression}
                      onChange={(e) => props.setRegression(e.target.value)}
                      isInvalid={!!props.errors.regression}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.regression}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Krushal (Importance Score):")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.krushal}
                      onChange={(e) => props.setKrushal(e.target.value)}
                      isInvalid={!!props.errors.krushal}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.krushal}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Shapely (Importance Score):")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.shapely}
                      onChange={(e) => props.setShapely(e.target.value)}
                      isInvalid={!!props.errors.shapely}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.shapely}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Correlation (Partial):")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.correlation}
                      onChange={(e) => props.setCorrelation(e.target.value)}
                      isInvalid={!!props.errors.correlation}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.correlation}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group as={Row} className="mb-3">
                  {formLabel("CHAID:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.chaid}
                      onChange={(e) => props.setChaid(e.target.value)}
                      isInvalid={!!props.errors.chaid}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.chaid}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Cluster:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.cluster}
                      onChange={(e) => props.setCluster(e.target.value)}
                      isInvalid={!!props.errors.cluster}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.cluster}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Factor:")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.factor}
                      onChange={(e) => props.setFactor(e.target.value)}
                      isInvalid={!!props.errors.factor}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.factor}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("BIP (Brand Image Profile):")}
                  <Col sm="6">
                    <Form.Control
                      as="select"
                      value={props.bIP}
                      onChange={(e) => props.setBIP(e.target.value)}
                      isInvalid={!!props.errors.bIP}
                    >
                      <option value="" hidden>
                        Yes/No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {props.errors.bIP}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Define Dependant Variable:")}
                  <Col sm="6">
                    <Form.Control
                      type="text"
                      value={props.dDV}
                      onChange={(e) => props.setDDV(e.target.value)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  {formLabel("Define Independent Variable:")}
                  <Col sm="6">
                    <Form.Control
                      type="text"
                      value={props.dIV}
                      onChange={(e) => props.setDIV(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      {/* --- SUBMIT BUTTON --- */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "20px 0",
        }}
      >
        <Button className="awnB" onClick={props.handleSubmit}>
          Submit
        </Button>
      </div>
      <br />
    </div>
  );
}

export default AwnFormUI;